import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import DynamicActionsTable from 'common/table/dynamic-actions-table';

const DateBlock = styled.li`
  margin-bottom: 25px;
  .ant-table-content {
    overflow-x: auto;
    overflow-y: hidden;
  }
  .ant-table-title {
    color: #fff;
    font-weight: 400;
    background-color: ${p =>
    p.specialDate ? p.theme.colors.timeline.specialDate : p.theme.colors.themeSecondary};
    padding: 0.75em 1em;
    font-size: 1rem;
    text-transform: uppercase;
  }
`;

const TimelineTable = ({
  tableconf,
  innerRef,
  specialDate,
  ...rest
}) =>
  <DateBlock ref={innerRef} specialDate={specialDate}>
    <DynamicActionsTable
      {...tableconf}
      hasDynamicActions={false}
      hasFooter={false}
      rowKey='id'
      isLoading={false}
      {...rest}
    />
  </DateBlock>;

const areEqual = (prevProps, nextProps) => !nextProps.datesToRerender.includes(nextProps.date);

TimelineTable.propTypes = {
  tableconf: PropTypes.object,
  innerRef: PropTypes.func,
  specialDate: PropTypes.bool,
  selectedRowKeys: PropTypes.array,
  datesToRerender: PropTypes.array,
  date: PropTypes.string,
};

export default React.memo(TimelineTable, areEqual);
